export const EVENT_SCHEDULE_TAB_PROGRAM = 'program',
    EVENT_SCHEDULE_TAB_MINE = 'mine',
    EVENT_SCHEDULE_TAB_TASKS = 'tasks',
    EVENT_SCHEDULE_TAB_TAGGED = 'tagged',
    EVENT_SCHEDULE_TAB_SEARCH = 'search';

export const EVENT_SCHEDULE_ALL_AVAILABLE_TABS = [
    //
    EVENT_SCHEDULE_TAB_PROGRAM,
    //
    EVENT_SCHEDULE_TAB_MINE,
    //
    EVENT_SCHEDULE_TAB_TASKS,
    //
    EVENT_SCHEDULE_TAB_TAGGED,
    //
    EVENT_SCHEDULE_TAB_SEARCH
];


export const EVENT_SCHEDULE_PREF_TABS = [
    //
    EVENT_SCHEDULE_TAB_PROGRAM,
    //
    EVENT_SCHEDULE_TAB_MINE,
    //
    EVENT_SCHEDULE_TAB_TASKS
]

export const EVENT_SCHEDULE_PREF_TAB_STORAGE_KEY = 'event_schedule_pref_tab';